module.exports = __webpack_public_path__ + "static/media/cei2.c8e6a193.png";